/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ host: NonNullable<unknown> }} Spaces_Open_Original_HintInputs */



/**
* | output |
* | --- |
* | "Opens the file in {host}. You need access there; otherwise {host} shows its own access-denied page." |
*
* @param {Spaces_Open_Original_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_open_original_hint = /** @type {((inputs: Spaces_Open_Original_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Open_Original_HintInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Öffnet die Datei in ${i?.host}. Dort brauchen Sie Zugriff, sonst zeigt ${i?.host} eine eigene Zugriffsverweigerung.`)
	return /** @type {LocalizedString} */ (`Opens the file in ${i?.host}. You need access there; otherwise ${i?.host} shows its own access-denied page.`)
});